import { render, staticRenderFns } from "./sideSessions.vue?vue&type=template&id=a17d5242&scoped=true"
import script from "./sideSessions.vue?vue&type=script&lang=js"
export * from "./sideSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17d5242",
  null
  
)

export default component.exports